export type ID = number | string | undefined

export const findById = <T extends { id: ID }>(data: T[], id: ID) =>
  data.find((item) => item.id === id)

export default findById
